import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

import { isProductionEnvironment } from "../../constants/Config";
import { AppEnvironmentConfig, Application } from "../../constants/AppConfigs";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights;
let loggedInUserId: number | null = null;

const loadInsights = (key: string) => {
  if (!key) {
    return;
  }
  appInsights = new ApplicationInsights({
    config: {
      connectionString: key,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
      enableAutoRouteTracking: true,
    },
  });
  appInsights.loadAppInsights();

  // Attach global telemetry properties
  appInsights.addTelemetryInitializer((envelope) => {
    const telemetryItem = envelope.baseData as any;
    telemetryItem.properties = {
      ...telemetryItem.properties,
      application: Application, // Identifies this as ConnectUI logs
      environment: isProductionEnvironment === 1 ? AppEnvironmentConfig.PROD : AppEnvironmentConfig.DEV, // Tracks deployment environment
      sessionId: getSessionId(), // Tracks user session
      userId: loggedInUserId, // Tracks authenticated user (if available)
      currentRoute: window.location.pathname, // Captures current React route
    };
  });
};

/**
 * Retrieves a session identifier to track logs per session.
 */
const getSessionId = (): string => {
  try {
    const match = document.cookie.split("; ").find((row) => row.startsWith("sessionId="));
    return match ? match.split("=")[1] : "";
  } catch {
    return "";
  }
};

/**
 * Retrieves the user ID from session or authentication state.
 */
const setUserId = (userId: number) => {
  if (userId) {
    loggedInUserId = userId;
  }
};

export { reactPlugin, appInsights, loadInsights, setUserId };
